import { PHILOSOPHY_TAGLINE, PROMPT_TAGS } from "../../../shared/index.js";

export const CORE_PHILOSOPHY = `${PROMPT_TAGS.CORE_PHILOSOPHY.open}
${PHILOSOPHY_TAGLINE}: inspect the project, record useful findings, adapt to its conventions, and act with verification.
${PROMPT_TAGS.CORE_PHILOSOPHY.close}`;
